module.exports = __webpack_public_path__ + "img/pageNav.21b67365.png";